import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Databaseservice } from "../../providers/databaseservice";
import { FirebaseListObservable } from "angularfire2";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
    
welcomeMsg: any;

constructor(public navCtrl: NavController) {
    this.welcomeMessage();
  }

welcomeMessage(){
    var today = new Date()
    var curHr = today.getHours()

    if (curHr < 12) {
      this.welcomeMsg = "Goedemorgen!";
    } else if (curHr < 18) {
      this.welcomeMsg = "Goedemiddag!";
    } else {
      this.welcomeMsg = "Goedeavond!"
    }
}
    
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts